import { DOCUMENT } from '@angular/common';
import { Injectable, Injector, inject } from '@angular/core';

import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { ScrollFreezeServiceTypes } from '@frontend/sports/common/core/feature/scroll-freeze';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { DialogSettings, ModalDialogService, ModalRef } from '@frontend/sports/modal/feature';
import { Store } from '@ngrx/store';

import { LineSwitcherActions } from '../actions';
import { LineSwitcherDialogContainerComponent } from '../components/line-switcher-dialog-container.component';
import { ISportPick } from '../models';

@Injectable()
export class LineSwitcherDialogService {
    private modalDialogRef: Nullable<ModalRef>;
    private readonly _doc = inject(DOCUMENT);

    constructor(
        private modalDialogService: ModalDialogService,
        private store: Store,
        private injector: Injector,
        private epcotConfig: EpcotConfig,
    ) {}

    openModalDialog(inColumn: boolean, optionGroup?: EventOptionGroup, event?: EventModel, pick?: ISportPick): void {
        this.closeModalDialog();

        const settings = this.getModalDialogSettings(inColumn);

        this.modalDialogRef = this.modalDialogService.openDialog(LineSwitcherDialogContainerComponent, {
            settings,
            data: {
                optionGroup,
                event,
                pick,
            },
        });

        if (this.modalDialogRef) {
            this.modalDialogRef.result.catch(() => this.close());
        }
    }

    closeModalDialog(): void {
        if (this.modalDialogRef) {
            this.modalDialogRef.close();
            this.modalDialogRef = null;
        }
    }

    private getModalDialogSettings(inColumn: boolean): DialogSettings {
        const modalDialogContainer = (inColumn && this._doc.querySelector<HTMLElement>('.column-right .widget-slot')) || void 0;
        const epcotClass = this.epcotConfig.isEnabled ? 'epcot-enabled' : '';

        const settings: DialogSettings = {
            fit: inColumn,
            isModalDialog: false,
            cssClass: `line-switcher-swap-dialog betslip-vars-scope ${epcotClass}`,
            inColumn,
            container: modalDialogContainer,
            scrollFreezeType: inColumn ? ScrollFreezeServiceTypes.None : ScrollFreezeServiceTypes.All,
            injector: this.injector,
        };

        return settings;
    }

    close(): void {
        this.store.dispatch(LineSwitcherActions.cancelLineSwitcher());
    }
}
